<template lang="">
  <div>
    <PositionGuid :posGuids="posGuids" class="gWidth"></PositionGuid>
    <div class="article gWidth bg-white" v-cloak>
      <!-- 公共位置 -->
      <!-- <div class="daohang  flex text-sm margin-bottom-lg">
        <span class="flex align-center">
          <span class="position margin-right-xs">
            <img src="@/assets/position.svg" />
          </span>
          <span class="weizhi">您的位置：</span>
        </span>
        <span>
          <span>
            <router-link to="/" class="text-sm">首页</router-link>
            <span>&gt;</span>
          </span>
          <span>
            <span class="text-sm grayss">{{ wdetails.fenlei }}</span>
            <span>&gt;</span>
          </span>
          <span>
            <span class="text-sm grayss">{{ wdetails.title }}</span>
          </span>
        </span>
      </div> -->
      <!-- 公共位置结束 -->
      <div class="arts">
        <p class="margin-top-lg text-center margin-bottom-lg title_p">
          {{ wdetails.title }}
        </p>
        <p class="text-center publish padding-bottom margin-bottom-lg text-sm">
          发布时间：{{ wdetails.created_at }}
        </p>
        <p
          class="text-sm table_width right_conts right_conts_p"
          v-html="wdetails.content"
        ></p>
        <div class="" v-if="wdetails.fj && wdetails.fj.length > 0">
          <p
            class="left flex"
            v-for="(item, indexfj) in wdetails.fj"
            :key="indexfj"
            style="margin-bottom: 10px;"
          >
            <!-- <a :href="'https://'+item.fujian" class="margin-right">附件{{indexfj+1}}：{{item.fjname}}</a> -->
            <a :href="item.fujian" class="margin-right">{{ item.fjname }}</a>
          </p>
          <!-- <p class="right"></p> -->
        </div>
        <!-- <p class="text-weight text-sm margin-top-lg margin-bottom-lg">相关热词搜索：</p> -->
        <!-- <div class="flex flex-between border-bottoms">
						<div class="flex ">
							<a href="javascript:;" class="lightgray text-sm margin-right-sm hover_a">[打印文章]</a>
							<a href="javascript:(alert('请按Ctrl+D组合键添加收藏'))" class="lightgray text-sm hover_a">[添加收藏]</a>
						</div>
						<div></div>
					</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { wdetail } from "@/api/gxq";
import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "Dxarticles",
  components: {
    PositionGuid,
  },
  data() {
    return {
      articleTitle: '保定国家高新技术产业开发区', // 初始标题
      contentSource: '保定国家高新技术产业开发区', // 初始内容来源

      wdetails: [],
      description: "",
      created_at: "",
      isLoading: false,
      // id: 1946,
      id: this.$route.params.id,
      posGuids: [
        {
          title: "",
          link: "",
        },
        {
          title: "",
          link: "",
        },
      ],
    };
  },
  mounted() {
    this.wdetail2();
  },
  methods: {

        // 清除具有指定名称的现有 meta 标签
        clearExistingMetaTags(name) {
        const existingTags = document.querySelectorAll(`meta[name="${name}"]`);
        existingTags.forEach(tag => tag.parentNode.removeChild(tag));
      },

 
      setArticleTitleMeta() {

      const articleTitleMeta = document.createElement('meta');
      articleTitleMeta.name = 'ArticleTitle';
      articleTitleMeta.content = this.articleTitle;

      const contentSourceMeta = document.createElement('meta');
      contentSourceMeta.name = 'ContentSource';
      contentSourceMeta.content = this.contentSource;

      const firstChild = document.head.firstChild;
      if (firstChild) {
        document.head.insertBefore(articleTitleMeta, firstChild);
        document.head.insertBefore(contentSourceMeta, firstChild);
      } else {
        document.head.appendChild(articleTitleMeta);
        document.head.appendChild(contentSourceMeta);
      }

    },

    async wdetail2() {
      const { data } = await wdetail({
        id: this.id,
      });
      this.wdetails = data[0];
      const regex = new RegExp("<img", "gi");
      this.wdetails.content = this.wdetails.content.replace(
        regex,
        `<img style="max-width:100%"`
        // `<img style="width:100%"`
      );

      // console.log(this.wdetails.content)
      this.articleTitle = data[0].title;
      this.clearExistingMetaTags('ArticleTitle');
      this.clearExistingMetaTags('ContentSource');
      this.setArticleTitleMeta();

      this.description = data[0].title;
      this.created_at = data[0].created_at;
      this.posGuids = [
        {
          title: this.wdetails.fenlei,
          link: "",
        },
        {
          title: this.wdetails.title,
          link: "",
        },
      ];
      // console.log(this.wdetails)
    },
  },
};
</script>
<style scoped="scoped">
.article {
  padding: 20px;
}

.mores_span span:nth-child(10) {
  display: block;
}

.publish {
  color: #666666;
  border-bottom: #dcdcdc 1px solid;
}

.border-bottoms {
  border-bottom: 1px solid #cccccc;
}

.title_p {
  font-weight: bold;
}

@media screen and (min-width: 1200px) {
  .title_p {
    font-size: 34px;
    line-height: 58px;
  }

  .arts {
    border: 1px solid #cccccc;
    padding: 28px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1199px) {
  .title_p {
    font-size: 28px;
    line-height: 50px;
  }

  .arts {
    border: 1px solid #cccccc;
    padding: 22px;
  }
}

@media screen and (max-width: 768px) {
  .title_p {
    font-size: 18px;
    line-height: 38px;
  }

  .arts {
    border: 1px solid #cccccc;
    padding: 12px;
  }
}
.table_width table {
  width: 100% !important;
}
</style>
<style>
.table_width table {
  width: 100% !important;
}
</style>
